module.exports = __webpack_public_path__ + "static/media/background_desktop.dd4cb8a1.png";